import { render } from "./DialogPromptNumeric.vue?vue&type=template&id=a96e9fee&ts=true"
import script from "./DialogPromptNumeric.vue?vue&type=script&lang=ts"
export * from "./DialogPromptNumeric.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__